import {
  HHToggleButton,
  HHToggleButtonGroup,
} from '@hinge-health/react-component-library';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import { GridLevelName } from '../../grid-components/grid-types';
import { BILL_DATE_FORMAT } from '../bill-grid-components/bill-management-types';
import { BillManagementNavigator } from './bill-management-navigator';

export interface ManagementViewToggleProps {
  currentView: GridLevelName;
}

export const ManagementViewToggle = ({
  currentView,
}: ManagementViewToggleProps): JSX.Element => {
  const navigate = useNavigate();

  const handleBillsViewClick = (): void => {
    BillManagementNavigator(
      {
        startDate: dayjs().subtract(90, 'days').format(BILL_DATE_FORMAT),
      },
      navigate,
      GridLevelName.BILL,
    );
  };

  const handleSubmissionsViewClick = (): void => {
    BillManagementNavigator(
      {
        submissionStartDate: dayjs()
          .subtract(90, 'days')
          .format(BILL_DATE_FORMAT),
      },
      navigate,
      GridLevelName.SUBMISSION,
    );
  };

  return (
    <HHToggleButtonGroup
      size="small"
      aria-label="management view toggle"
      sx={{ height: '40px' }}
    >
      <HHToggleButton
        hhVariant="variant-bypass"
        selected={currentView === GridLevelName.BILL}
        value={GridLevelName.BILL}
        onClick={(_e): void => handleBillsViewClick()}
        aria-label="bill management view"
        data-testid="bill-management-toggle"
        sx={{ borderRadius: '4px 0 0 4px', textTransform: 'none' }}
      >
        Bills
      </HHToggleButton>
      <HHToggleButton
        hhVariant="variant-bypass"
        selected={currentView === GridLevelName.SUBMISSION}
        value={GridLevelName.SUBMISSION}
        onClick={(_e): void => handleSubmissionsViewClick()}
        aria-label="submission management view"
        data-testid="submission-management-toggle"
        sx={{ borderRadius: '0 4px 4px 0', textTransform: 'none' }}
      >
        Submissions
      </HHToggleButton>
    </HHToggleButtonGroup>
  );
};
